module.exports = __webpack_public_path__ + "img/search-empty.d99b4749.svg";